import { Range, Threshold } from "@/types/types"

export const defaultRange: Range = {
  enabled: false,
  min: 0,
  max: 0
}

export const defaultThreshold: Threshold = {
  max: {
    enabled: false,
    value: 0
  },
  min: {
    enabled: false,
    value: 0
  }
}
